import { Link2, ScrollText, Type, ListTree, Search } from "lucide-react";
import AdminTabsHub from "@/pages/admin/AdminTabsHub";
import AdminVisibility from "@/pages/admin/AdminVisibility";
import AdminPages from "@/pages/admin/AdminPages";
import AdminPageHeadings from "@/pages/admin/AdminPageHeadings";
import AdminNavigation from "@/pages/admin/AdminNavigation";
import AdminLegal from "@/pages/admin/AdminLegal";
import AdminSeo from "@/pages/admin/AdminSeo";

export default function AdminSitePagesHub() {
  return (
    <AdminTabsHub
      idPrefix="sitepages"
      title="Pages & SEO"
      subtitle="Page addresses & visibility, the Pages Manager, page titles, the navigation builder, legal pages and SEO — unified."
      tabs={[
        { key: "addresses", label: "Pages & Addresses", icon: Link2, render: () => <AdminVisibility /> },
        { key: "manager", label: "Pages Manager", icon: ScrollText, render: () => <AdminPages /> },
        { key: "titles", label: "Page Titles", icon: Type, render: () => <AdminPageHeadings /> },
        { key: "navigation", label: "Navigation Builder", icon: ListTree, render: () => <AdminNavigation /> },
        { key: "legal", label: "Legal Pages", icon: ScrollText, render: () => <AdminLegal /> },
        { key: "seo", label: "SEO & Keywords", icon: Search, render: () => <AdminSeo /> },
      ]}
    />
  );
}
